<template>
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          项目扶持
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          六大运营扶持，盈利更有保障
        </div>
      </div>
    </div>

    <!-- 内容框 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto grid grid-cols-3 gap-[1.46vw]"
    >
      <div
        v-for="(item, index) in contentItems"
        :key="index"
        class="group w-[19.27vw] h-auto bg-white rounded-xl inline-flex flex-col justify-start items-center overflow-hidden relative transition-all duration-300 hover:shadow-[0_0.6vw_1.5vw_rgba(0,0,0,0.15)]"
      >
        <el-image
          :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/home/module5/image${index+1}.png`"
          class="w-full h-[11.46vw] rounded-tl-xl rounded-tr-xl object-cover transition-transform duration-300 group-hover:scale-110"
          lazy
          alt="图片"
        />
        <div
          class="relative w-full flex flex-col justify-start items-center gap-[0.21vw] py-[2.14vw] cursor-default"
        >
          <div
            class="relative w-full flex justify-center items-start text-center text-[#1A2233] text-[1.15vw] font-bold font-harmony transition-colors duration-300 group-hover:text-[#05358c]"
          >
            {{ item.title }}
          </div>
          <div
            class="relative w-full flex justify-center items-start text-center text-[#9CA3AF] text-[0.83vw] font-normal font-harmony whitespace-pre-line"
          >
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-module5",
  data() {
    return {
      contentItems: [
        {
          title: "课程体系全",
          description: "教材、教具、实验室设计方案\n及师资培训全链路课程体系",
        },
        {
          title: "白名单赛事",
          description: "全方位提供专业、权威的无人机\n赛事指导与支持",
        },
        {
          title: "全方位培训",
          description: "为合作伙伴提供全方位的培训\n精心规划师训流程",
        },
        {
          title: "投资轻量化",
          description: "低门槛加盟费，灵活合作模式\n（县区级/市级/省级）",
        },
        {
          title: "落地高效化",
          description: "30天建设，7天师资\n培训结业",
        },
        {
          title: "运营标准化",
          description: "AI管理系统 + 总部全程督导 +\n后期营销赋能",
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>